import {
  Button,
  Col,
  Divider,
  Form,
  Icon,
  Input,
  Modal,
  Row,
  Select,
  Spin,
  Switch,
  Table,
  Tabs,
  Tag,
  Tooltip,
} from 'antd';
import axios from 'axios';
import qs from 'qs';
import React, { Component } from 'react';
import Moment from 'react-moment';
import { Constant } from '../../config';
import MyModal from '../Modal';
import SearchForm from '../SearchForm';

Moment.globalLocal = false;
const { TabPane } = Tabs;

const modalName = 'country-restrictions';

class MemberCountryRestrictionsModal extends Component {
  state = {
    loading: false,
    dataSource: [],
    current_data: {},
    countryRestrictionsData: [],
    visibleFormModal: false,
  };

  columns = [
    {
      title: 'ประเทศ',
      dataIndex: 'country_restriction_id',
      render: (text, record) => {
        let countryName =
          record.country_restrictions_detail &&
          record.country_restrictions_detail.country_detail
            ? record.country_restrictions_detail.country_detail.name
            : '';
        let regionCode = record.country_restrictions_detail
          ? record.country_restrictions_detail.region_code
          : '';

        return (
          <span>
            <span style={{ fontWeight: 'bold' }}>{countryName}</span>
            <br />
            <Tag color="blue">Code: {regionCode}</Tag>
            <Tag color="orange">
              แก้ไขล่าสุดเมื่อ (UTC):
              <Moment unix tz="Etc/UTC" format="MMM DD YYYY HH:mm:ss">
                {record.updated}
              </Moment>
            </Tag>
          </span>
        );
      },
    },
    {
      title: 'เปิด / ปิด',
      dataIndex: 'is_disabled',
      render: (text, record) => {
        return (
          <Switch
            checkedChildren={<Icon type="check" />}
            unCheckedChildren={<Icon type="close" />}
            defaultChecked={!text}
            onChange={(e) => this.toggleStatus(e, record.id)}
          />
        );
      },
    },
    {
      title: 'ดำเนินการ',
      dataIndex: 'id',
      render: (text, record) => {
        return (
          <Tooltip placement="top" title="ลบ">
            <Button type="danger" icon="delete" onClick={() => this._delete(text)} />
          </Tooltip>
        );
      },
    },
  ];
  columnsMobile = [
    {
      title: 'ประเทศ',
      dataIndex: 'country_restriction_id',
      render: (text, record) => {
        let countryName =
          record.country_restrictions_detail &&
          record.country_restrictions_detail.country_detail
            ? record.country_restrictions_detail.country_detail.name
            : '';
        let regionCode = record.country_restrictions_detail
          ? record.country_restrictions_detail.region_code
          : '';

        return (
          <span>
            <span style={{ fontWeight: 'bold' }}>{countryName}</span>
            <br />
            <Tag color="blue">Code: {regionCode}</Tag>
            <Tag color="orange">
              แก้ไขล่าสุดเมื่อ (UTC):
              <Moment unix tz="Etc/UTC" format="MMM DD YYYY HH:mm:ss">
                {record.updated}
              </Moment>
            </Tag>
            <Divider className="my-divider" dashed orientation="left">
              ดำเนินการ
            </Divider>
            <Row>
              <Col span={12}>
                <Switch
                  checkedChildren={<Icon type="check" />}
                  unCheckedChildren={<Icon type="close" />}
                  defaultChecked={!record.is_disabled}
                  onChange={(e) => this.toggleStatus(e, record.id)}
                />
              </Col>
              <Col span={12}>
                <Button
                  type="danger"
                  icon="delete"
                  onClick={() => this._delete(record.id)}
                />
              </Col>
            </Row>
          </span>
        );
      },
    },
  ];
  currentSearch = '';
  currentSmsType = 'outbound';

  componentDidUpdate = async (prevProps, prevState) => {
    const { data: pd } = prevProps;
    const { data: d } = this.props;

    if (
      d &&
      d.memberId &&
      typeof d.memberId !== 'undefined' &&
      d.memberId !== pd.memberId &&
      d.modalName === modalName
    ) {
      this.setState({
        dataSource: await this._getList(d.memberId, this.currentSmsType),
      });
    }
  };

  toggleStatus = async (f, id) => {
    this.setState({ loading: true });

    let url = Constant.MEMBER_COUNTRY_RESTRICTIONS_DISABLE_API;
    if (f) {
      url = Constant.MEMBER_COUNTRY_RESTRICTIONS_ENABLE_API;
    }

    let opt = {
      url: url.replace('[id]', id),
      method: 'PUT',
      headers: {
        Authorization: 'Bearer ' + localStorage.getItem(Constant.SessionKey),
      },
    };
    let resp;
    let eMsg = 'เกิดข้อผิดพลาด ไม่สามารถแก้ไขข้อมูลได้ กรุณาลองใหม่อีกครั้ง';
    let eMsgDetail = '';
    let eFlag = false;

    try {
      resp = await axios(opt);
    } catch (err) {
      resp = err.response;
    }

    if (!resp.data) {
      eFlag = true;
    } else if (resp.data.error) {
      eFlag = true;
      let e = resp.data.error;
      eMsgDetail = `[${e.code}] ${e.name}`;
    }

    if (eFlag) {
      MyModal.error(eMsg, eMsgDetail, () => {
        window.location.reload();
      });
    } else {
      this.setState({ loading: false });
    }
  };

  _create = async () => {
    if (typeof this.props.data === 'undefined' || this.props.data.memberId < 1) {
      MyModal.error(
        'เกิดข้อผิดพลาด ไม่สามารถดึงข้อมูลได้ กรุณาลองใหม่อีกครั้ง',
        '',
        () => {
          window.location.reload();
        },
      );
      return;
    }

    this.setState({
      current_data: {
        member_id: this.props.data.memberId,
        country_restrictions_id: undefined,
        sms_type: this.currentSmsType,
      },
      visibleFormModal: true,
      countryRestrictionsData: await this._getCountryRestrictionsList(
        this.props.data.memberId,
        this.currentSmsType,
      ),
    });
  };

  _delete = (id) => {
    MyModal.confirm(
      'คุณต้องการลบข้อมูล ใช่หรือไม่ ?',
      '',
      async (f) => {
        if (!f) return;

        this.setState({ loading: true });

        let opt = {
          url: Constant.MEMBER_COUNTRY_RESTRICTIONS_EDIT_API.replace('[id]', id),
          method: 'DELETE',
          headers: {
            Authorization: 'Bearer ' + localStorage.getItem(Constant.SessionKey),
          },
        };
        let resp;
        let modeTxt = 'ลบ';
        let eMsg = `เกิดข้อผิดพลาด ไม่สามารถ${modeTxt}ข้อมูลได้ กรุณาลองใหม่อีกครั้ง`;
        let eMsgDetail = '';
        let eFlag = false;

        try {
          resp = await axios(opt);
        } catch (err) {
          resp = err.response;
        }

        if (!resp.data) {
          eFlag = true;
        } else if (resp.data.error) {
          eFlag = true;
          let e = resp.data.error;
          eMsgDetail = `[${e.code}] ${e.name}`;
        }

        if (eFlag) {
          MyModal.error(eMsg, eMsgDetail, () => {
            window.location.reload();
          });
        } else {
          MyModal.info(`${modeTxt}ข้อมูลสำเร็จ`, '', async () => {
            this.resetSearch();
          });
        }
      },
      'ใช่',
      'ไม่ใช่',
    );
  };

  formHandleSubmit = () => {
    const { form } = this.formRef.props;

    form.validateFields(async (err, values) => {
      if (err) return;

      this.setState({
        visibleFormModal: false,
        loading: true,
      });

      let url = Constant.MEMBER_COUNTRY_RESTRICTIONS_API;
      let opt = {
        url,
        method: 'POST',
        data: qs.stringify(values),
        headers: {
          Authorization: 'Bearer ' + localStorage.getItem(Constant.SessionKey),
          'Content-Type': 'application/x-www-form-urlencoded',
        },
      };
      let resp;
      let modeTxt = 'เพิ่ม';
      let eMsg = `เกิดข้อผิดพลาด ไม่สามารถ${modeTxt}ข้อมูลได้ กรุณาลองใหม่อีกครั้ง`;
      let eMsgDetail = '';
      let eFlag = false;

      try {
        resp = await axios(opt);
      } catch (err) {
        resp = err.response;
      }

      if (!resp.data) {
        eFlag = true;
      } else if (resp.data.error) {
        eFlag = true;
        let e = resp.data.error;
        eMsgDetail = `[${e.code}] ${e.name}`;
      }

      if (eFlag) {
        MyModal.error(eMsg, eMsgDetail, () => {
          window.location.reload();
        });
      } else {
        MyModal.info(`${modeTxt}ข้อมูลสำเร็จ`, '', () => {
          this.resetSearch();
        });
      }
    });
  };

  formHandleCancel = () => {
    this.setState({ visibleFormModal: false });
  };

  saveFormRef = (formRef) => {
    this.formRef = formRef;
  };

  mySearch = (fd) => {
    fd.validateFields(async (err, values) => {
      if (err) return;

      if (typeof this.props.data === 'undefined' || this.props.data.memberId < 1) {
        MyModal.error(
          'เกิดข้อผิดพลาด ไม่สามารถดึงข้อมูลได้ กรุณาลองใหม่อีกครั้ง',
          '',
          () => {
            window.location.reload();
          },
        );
        return;
      }

      this.setState({ loading: true });
      this.currentSearch = values.searchTxt;
      this.setState({
        dataSource: await this._getList(
          this.props.data.memberId,
          this.currentSmsType,
          this.currentSearch,
        ),
        loading: false,
      });
    });
  };

  resetSearch = async () => {
    if (typeof this.props.data === 'undefined' || this.props.data.memberId < 1) {
      MyModal.error(
        'เกิดข้อผิดพลาด ไม่สามารถดึงข้อมูลได้ กรุณาลองใหม่อีกครั้ง',
        '',
        () => {
          window.location.reload();
        },
      );
      return;
    }

    this.setState({ loading: true });
    this.currentSearch = '';
    this.setState({
      dataSource: await this._getList(
        this.props.data.memberId,
        this.currentSmsType,
        this.currentSearch,
      ),
      loading: false,
    });
  };

  _getList = async (memberId, smsType, search = '') => {
    let url =
      Constant.MEMBER_COUNTRY_RESTRICTIONS_API +
      '?limit=0&sms_type=' +
      smsType +
      '&member_id=' +
      memberId +
      '&search=' +
      search;

    let opt = {
      url,
      method: 'GET',
      headers: {
        Authorization: 'Bearer ' + localStorage.getItem(Constant.SessionKey),
      },
    };
    let resp;

    try {
      resp = await axios(opt);
    } catch (err) {
      resp = err.response;
    }

    if (!resp.data) {
      console.log(resp.data);
      return [];
    }

    if (resp.data.error) {
      console.log(resp.data.error);
      return [];
    }

    this.totalRows = resp.data.total_rows || 0;

    return resp.data.data;
  };

  _getCountryRestrictionsList = async (memberId, smsType) => {
    let url =
      Constant.COUNTRY_RESTRICTIONS_API +
      '?limit=0&sms_type=' +
      smsType +
      '&member_id=' +
      memberId;

    let opt = {
      url,
      method: 'GET',
      headers: {
        Authorization: 'Bearer ' + localStorage.getItem(Constant.SessionKey),
      },
    };
    let resp;

    try {
      resp = await axios(opt);
    } catch (err) {
      resp = err.response;
    }

    if (!resp.data) {
      console.log(resp.data);
      return [];
    }

    if (resp.data.error) {
      console.log(resp.data.error);
      return [];
    }

    return resp.data.data;
  };

  tabsChange = (key) => {
    this.currentSmsType = key;
    this.child.clearTxtSearch();
    this.resetSearch();
  };

  smsTypeOnSelect = async (val) => {
    if (this.currentSmsType === val) return;

    if (typeof this.props.data === 'undefined' || this.props.data.memberId < 1) {
      MyModal.error(
        'เกิดข้อผิดพลาด ไม่สามารถดึงข้อมูลได้ กรุณาลองใหม่อีกครั้ง',
        '',
        () => {
          window.location.reload();
        },
      );
      return;
    }

    this.currentSmsType = val;
    this.setState({
      dataSource: await this._getList(
        this.props.data.memberId,
        this.currentSmsType,
        this.currentSearch,
      ),
      countryRestrictionsData: await this._getCountryRestrictionsList(
        this.props.data.memberId,
        this.currentSmsType,
      ),
    });
  };

  render() {
    const { visible, onCancel, data } = this.props;
    let title =
      'Country Restrictions' +
      (data && data.memberName ? ' ของ ' + data.memberName + ' ที่ลงทะเบียนแล้ว' : '');
    let propsTable = {
      className: 'my-table',
      columns: this.columns,
      dataSource: this.state.dataSource,
      rowKey: 'id',
      pagination: false,
    };
    let propsTableForMobile = Object.assign({}, propsTable);
    propsTableForMobile.className = 'my-table-mobile';
    propsTableForMobile.columns = this.columnsMobile;

    return (
      <Modal
        className="my-layout"
        visible={visible}
        maskClosable={false}
        onCancel={onCancel}
        title={title}
        width={800}
        footer={[
          <Button key="cancel" onClick={onCancel}>
            ปิด
          </Button>,
        ]}
        style={{ top: 20 }}
      >
        <Spin spinning={this.state.loading} tip="กำลังโหลดข้อมูล...">
          <Row className="utility-bar">
            <Col span={12}>
              <Button onClick={() => this._create()}>
                <Icon type="plus-circle" />
                เพิ่ม
              </Button>
            </Col>
            <Col span={12}>
              <SearchForm
                fn={this.mySearch}
                fnReset={this.resetSearch}
                onRef={(ref) => (this.child = ref)}
              />
            </Col>
          </Row>
          <Row className="utility-bar-mobile">
            <Button block onClick={() => this._create()}>
              <Icon type="plus-circle" />
              เพิ่ม
            </Button>
          </Row>
          <Row className="utility-bar-mobile">
            <SearchForm
              fn={this.mySearch}
              fnReset={this.resetSearch}
              onRef={(ref) => (this.child = ref)}
            />
          </Row>
          <Tabs onChange={this.tabsChange} activeKey={this.currentSmsType}>
            <TabPane tab="SMS" key="outbound">
              <Table {...propsTable} />
              <Table {...propsTableForMobile} />
            </TabPane>
            <TabPane tab="VERIFY" key="verify">
              <Table {...propsTable} />
              <Table {...propsTableForMobile} />
            </TabPane>
          </Tabs>
        </Spin>
        <MemberCountryRestrictionsForm
          wrappedComponentRef={this.saveFormRef}
          visible={this.state.visibleFormModal}
          onCancel={this.formHandleCancel}
          onCreate={this.formHandleSubmit}
          data={this.state.current_data}
          countryRestrictionsData={this.state.countryRestrictionsData}
          smsTypeOnSelect={this.smsTypeOnSelect}
        />
      </Modal>
    );
  }
}

const MemberCountryRestrictionsForm = Form.create({
  name: 'member_country_restrictions_form',
})(
  class extends Component {
    componentDidUpdate = async (prevProps, prevState) => {
      const { data: pd } = prevProps;
      const { data: d, form } = this.props;

      if (d && d.sms_type !== pd.sms_type) {
        form.setFieldsValue(d);
      }
    };

    render() {
      const {
        visible,
        onCreate,
        onCancel,
        form,
        countryRestrictionsData,
        smsTypeOnSelect,
      } = this.props;
      const { getFieldDecorator } = form;

      return (
        <Modal
          visible={visible}
          title="เพิ่มใหม่"
          okText="เพิ่ม"
          cancelText="ยกเลิก"
          onCancel={onCancel}
          onOk={onCreate}
          maskClosable={false}
        >
          <Form layout="vertical" className="verify_template_form">
            {getFieldDecorator('member_id')(<Input type="hidden" />)}
            <Form.Item label="ประเภท SMS">
              {getFieldDecorator(
                'sms_type',
                {},
              )(
                <Select onSelect={smsTypeOnSelect}>
                  <Select.Option value="outbound">SMS</Select.Option>
                  <Select.Option value="verify">VERIFY</Select.Option>
                </Select>,
              )}
            </Form.Item>
            <Form.Item label="ประเทศ">
              {getFieldDecorator('country_restrictions_id', {
                rules: [{ required: true, message: 'กรุณาเลือกประเทศ' }],
              })(
                <Select placeholder="เลือกประเทศ">
                  {countryRestrictionsData.map((v, i) => (
                    <Select.Option key={v.id} value={v.id}>
                      {v.country_detail ? v.country_detail.name : v.region_code}
                    </Select.Option>
                  ))}
                </Select>,
              )}
            </Form.Item>
          </Form>
        </Modal>
      );
    }
  },
);

export default MemberCountryRestrictionsModal;



// WEBPACK FOOTER //
// ./src/containers/User/MemberCountryRestrictionsModal.js